/* eslint-disable-jsx-a11y/anchor-is-valid*/
import React from 'react'
import {Grid,} from '@material-ui/core'
import {listDefaults} from './config'
import AppButton from '../Common/AppButton'
import MUIDataTables from 'mui-datatables'
import { colors } from '../../shared/colors';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { TableCell, TableRow } from "@material-ui/core";
import { styled } from '@material-ui/styles';


export default function UploadFilesList(props){

    const {removeFileUploadAction, title} = listDefaults

    const {
            listProps:{
                files, 
                removeFile,
                header=title,
                deleteIcon=removeFileUploadAction.icon,
            }
        } = props
    
    const _header = props.header || header
    const _deleteIcon = props.deleteIcon || deleteIcon

    const getMuiTheme = () => createTheme({
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: 'white',
                },
            },
        }
    })

    const deleteAction = index =>  {
        return (
            <AppButton 
                {...removeFileUploadAction}
                label="Remove File"
                icon={_deleteIcon}
                onClick={removeFile ? ()=>removeFile(index) : null}
            />
        )
    }

    const data = files.map( (file, index) => ({index: `${index + 1}.`, name: file.name, action: deleteAction(index)}) )

    const categories = [
        { name: "index", label: 'File #' },
        { name: "name", label: 'File Name' },
        { name: "action", label: 'Action' },
    ];

    const options = {
        empty: true,
        setCellHeaderProps: () => ({
            style: {
                backgroundColor: colors.dhcsBlue,
            }
        })
    }

    const columns = categories.map( col => ({...col, options}) );

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: colors.dhcsAccentGray,
        }
      }));

    const tableOptions = {
        print: false,
        download: false,
        viewColumns: false,
        filter: false,
        search: false,
        sort: false,
        selectableRows: 'none',
        responsive: 'scrollMaxHeight',
        rowsPerPageOptions: [5, 10],
        rowsPerPage: 5,
        fixedHeader: false,
        customRowRender: (data) => {
            return (
              <StyledTableRow>
                {data.map(label => {
                    return(
                        <TableCell>{label}</TableCell>
                    )
                })}
              </StyledTableRow>
            );
          },
    }

    const filesList =  (
        <MuiThemeProvider theme={getMuiTheme()}>
            <MUIDataTables
                title={_header}
                data={data}
                columns={columns}
                options={tableOptions}
            />
        </MuiThemeProvider>
    )

    return (
        <Grid container item xs={12}>
            { files.length > 0 &&
                <div style={{width: 'inherit'}}>
                    {filesList}
                </div>
            }
        </Grid>
    )
}